<template>
  <span v-if="kpi">{{formattedValue}}</span>
</template>

<script>
const FORMATTING = Object.freeze({
  Default: 0,           /* xx% */
  None: 1,              /* xx */
  Time: 2,              /* xx:yy h */
  Time_Dynamic: 3,      /* xx Min || xx:yy h */
  Minutes: 4,           /* xx Min */
  Hours: 5,             /* < 1 h || xx h */
});

export default {
  name: "FormatKpiValue",
  props: {
    kpi: Object,
    format: {
      type: Number,
      default: 0
    },
    isThreshold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedValue() {
      let value;
      let thresholdSubstring = '';
      if(this.isThreshold) {
        value = this.kpi.QuestionThreshold;
        if(this.kpi.ThresholdDirection == 'BELOW') {
          thresholdSubstring = this.$t('Webportal.CX.Threshold.Max');
        } else if (this.kpi.ThresholdDirection == 'ABOVE') {
          thresholdSubstring = this.$t('Webportal.CX.Threshold.Min');
        }
        
      } else {
        value = this.format == FORMATTING.Time ? this.kpi.QuestionResult : this.kpi.Result;
      }
      

      // Show 'N / A'
      if (value == null || isNaN(value)){
        return this.$t('Webportal.CX.Dashboard.Exploration.NoData');
      } 
      
      switch(this.format)
      {
        case FORMATTING.None:
          return value;

        case FORMATTING.Time_Dynamic:
          if (value < 60)
            return `${this.isThreshold ? thresholdSubstring : ''}${value} Min`;
        // -> Fall through
        case FORMATTING.Time:
          return `${this.isThreshold ? thresholdSubstring : ''}${Math.floor(value / 60)}:${('0' + value % 60).slice(-2)} h`;

        case FORMATTING.Minutes:
          return `${this.isThreshold ? thresholdSubstring : ''}${value} Min`;

        case FORMATTING.Hours:
          return value < 60 ? `< 1 h` : `${this.isThreshold ? thresholdSubstring : ''}${Math.floor(value / 60)} h`;

        default:
          return `${this.isThreshold ? thresholdSubstring : ''}${value}%`;
      }
    }
  }
}
</script>